// extracted by mini-css-extract-plugin
export default {"formSelectCustom":"FormSelectCustom_formSelectCustom__PyfjA"};